'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _util = require('../util');

exports.default = {
  authenticate: function authenticate(api, data, fragment, userAction, context) {
    var args = (0, _util.serializeFields)(['email', 'password', 'app', 'device'], data);
    var query = 'mutation { signIn(' + args + ') { ' + fragment + ' } }';

    var queryName = 'signIn';
    return (0, _util.wrapAction)(userAction, queryName, 'authenticate', api.fetch(query, {}, queryName), context);
  },
  facebookLogin: function facebookLogin(api, data, fragment, userAction, context) {
    var args = (0, _util.serializeFields)(['fbAccessToken', 'app', 'device'], data);
    var query = 'mutation { fbLogin(' + args + ') { ' + fragment + ' } }';

    var queryName = 'fbLogin';
    return (0, _util.wrapAction)(userAction, queryName, 'authenticate', api.fetch(query, {}, queryName), context);
  },
  register: function register(api, data) {
    var fragment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
    var userAction = arguments[3];
    var context = arguments[4];

    var args = (0, _util.serializeFields)(['email', 'password', 'name', 'lastName', 'app', 'device'], data);
    var query = 'mutation { signUp(' + args + ') { ' + fragment + ' } }';

    var queryName = 'signUp';
    return (0, _util.wrapAction)(userAction, queryName, 'register', api.fetch(query, {}, queryName), context);
  },
  logout: function logout(api, userAction) {
    var query = 'mutation { signOut }';

    var queryName = 'signOut';
    return (0, _util.wrapAction)(userAction, queryName, 'logout', api.fetch(query, {}, queryName));
  },
  loadCurrentUser: function loadCurrentUser(api, fragment, userAction) {
    if (!fragment) {
      fragment = '\n        id\n        name\n        accessToken\n      ';
    }

    var query = '\n      query {\n        me {\n          ' + fragment + '\n        }\n      }\n    ';

    var queryName = 'me';
    return (0, _util.wrapAction)(userAction, queryName, 'loadCurrentUser', api.fetch(query, {}, queryName));
  },
  loadUserOrders: function loadUserOrders(api, params, userAction) {
    var paramsDefault = {
      limit: 3
    };

    if (params.type) {
      params.type = (0, _util.serializeEnum)(params.type);
    }

    params = (0, _util.serializeForMutation)(_extends({}, paramsDefault, params));

    var fragment = '\n      orders(' + params + ') {\n        id\n        status\n        date\n        name\n        confirmation {\n          date\n        }\n        type\n        total\n        restaurant {\n          id\n        }\n        items {\n          id\n          name\n          quantity\n          price\n          modifiers {\n            id\n            name\n            items {\n              id\n              name\n              price\n            }\n          }\n        }\n        extraCosts {\n          label\n          amount\n          type\n        }\n        paymentType\n        email\n        phoneNumber\n        address {\n          route\n          street_number\n          postal_code\n          city\n          country\n          citofono\n        }\n        addressInfo\n        location {\n          lat\n          lng\n        }\n      }\n    ';

    var query = '\n      query {\n        me {\n          ' + fragment + '\n        }\n      }\n    ';

    var queryName = 'me';
    return (0, _util.wrapAction)(userAction, queryName, 'loadUserOrders', api.fetch(query, {}, queryName));
  },
  loadUserBookingRequests: function loadUserBookingRequests(api, params, userAction) {
    var paramsDefault = {
      limit: 3
    };

    if (params.type) {
      params.type = (0, _util.serializeEnum)(params.type);
    }

    params = (0, _util.serializeForMutation)(_extends({}, paramsDefault, params));

    var fragment = '\n      bookingRequests(' + params + ') {\n        id\n        app\n        name\n        lastName\n        phoneNumber\n        email\n        date\n        people\n        type\n        status\n        extraInfo\n        insertedAt\n        updatedAt\n        sourceType\n        restaurant {\n          id\n        }\n        availabilitySlot {\n          open\n          close\n        }\n        user {\n          id\n        }\n      }\n    ';

    var query = '\n      query {\n        me {\n          ' + fragment + '\n        }\n      }\n    ';

    var queryName = 'me';
    return (0, _util.wrapAction)(userAction, queryName, 'loadUserBookingRequests', api.fetch(query, {}, queryName));
  },
  loadCreditCards: function loadCreditCards(api, params, userAction) {
    var fragment = '\n      creditCards {\n        id\n        brand\n        country\n        exp_month\n        exp_year\n        last4\n      }\n    ';

    var query = '\n      query {\n        me {\n          ' + fragment + '\n        }\n      }\n    ';

    var queryName = 'me';
    return (0, _util.wrapAction)(userAction, queryName, 'loadCreditCards', api.fetch(query, {}, queryName));
  },
  deleteCreditCard: function deleteCreditCard(api, params, userAction) {
    var fragment = '\n      {\n        id\n        brand\n        country\n        exp_month\n        exp_year\n        last4\n      }\n    ';

    var query = 'mutation { deleteCreditCard(cardId: "' + params.cardId + '") ' + fragment + ' }';
    var queryName = 'deleteCreditCard';
    return (0, _util.wrapAction)(userAction, queryName, 'deleteCreditCard', api.fetch(query, {}, queryName));
  },
  storeCreditCardToken: function storeCreditCardToken(api, data, userAction) {
    // TODO questa roba probabilmente non va, e la mutation non esiste sulle api ^^'
    var args = (0, _util.serializeFields)(['lastDigits', 'token', 'app', 'device', 'user'], data);
    var query = 'mutation { storeCreditCardToken(' + args + ') }';
    var queryName = 'storeCreditCardToken';
    return (0, _util.wrapAction)(userAction, queryName, 'storeCreditCardToken', api.fetch(query, {}, queryName));
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-lib/lib/service/user.js
// module id = 203
// module chunks = 0